import bookmark from './bookmark';
import create from './create';
import deleteCoverPhoto from './delete_cover_photo';
import edit from './edit';
import like from './like';
import list from './list';
import listLatest from './list_latest';
import mostRatedRecipes from './most_rated_recipes';
import onBookmarkedRecipes from './on_bookmarked_recipes';
import onMyRecipesReceived from './on_my_recipes_received';
import read from './read';
import wasBookmarked from './was_bookmarked';
import wasLiked from './was_liked';
import uploadCoverPhoto from './upload_cover_photo';

const RecipesService = {
  bookmark,
  create,
  edit,
  deleteCoverPhoto,
  like,
  list,
  listLatest,
  mostRatedRecipes,
  onBookmarkedRecipes,
  onMyRecipesReceived,
  read,
  wasLiked,
  wasBookmarked,
  uploadCoverPhoto,
};

export default RecipesService;
